import LearnPageLayout from "@/components/LearnPageLayout";
import { pageSaintVsSpravato } from "./learnDataSaintVsSpravato";

const SaintVsSpravatoPage = () => (
  <LearnPageLayout
    title={pageSaintVsSpravato.title}
    description={pageSaintVsSpravato.description}
    canonical={pageSaintVsSpravato.canonical}
    h1={pageSaintVsSpravato.h1}
    breadcrumbLabel={pageSaintVsSpravato.breadcrumbLabel}
    crumbs={pageSaintVsSpravato.crumbs}
    shortAnswer={pageSaintVsSpravato.shortAnswer}
    keyTakeaways={pageSaintVsSpravato.keyTakeaways}
    sections={pageSaintVsSpravato.sections}
    faqs={pageSaintVsSpravato.faqs}
    sources={pageSaintVsSpravato.sources}
    schemaJson={pageSaintVsSpravato.schemaJson}
    relatedLinks={pageSaintVsSpravato.relatedLinks}
    reviewBlock={pageSaintVsSpravato.reviewBlock}
  />
);

export default SaintVsSpravatoPage;
